import React, { useEffect, useState } from 'react';
import { Radios, Button, ErrorSummary, Fieldset } from 'govuk-react-jsx';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  setPMCLandlordsData,
  getPMCLandlordsData,
  setSelectedLandlord,
  getSelectedLandlord,
  setSelectedLandlordClient,
} from '../../features/pmc/pmcJourneySlice';
import { getAccount } from '../../firebase';
import useTitle from '../../hooks/useTitle';
import useGaStartEvent from '../../hooks/useGaStartEvent';

const ChooseLandlord = () => {
  const pmcLandlordsDataRedux = useSelector(getPMCLandlordsData);
  const selectedLandlordRedux = useSelector(getSelectedLandlord);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorList, setErrorList] = useState([]);

  useTitle(
    'pmcApp.ChooseLandlord.s5',
    'Who is this application for? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  useGaStartEvent('PmcSubmitClaim', 'pmc_claim_start');

  // Error message
  const errorRadioSelectMsg = copyProvider.getCopy(
    'pmcApp.ChooseLandlord.s4',
    'Select a client to start an application for'
  );

  const handleSelectionBtn = (event) => {
    dispatch(setSelectedLandlord(event.target.value));
    const selectedLandlordClient = pmcLandlordsDataRedux.filter(
      (item) => item.landlord_account_id === event.target.value
    );
    dispatch(setSelectedLandlordClient(selectedLandlordClient[0]));
  };

  const handleSubmitButton = () => {
    const showRadioErrorMsg = {
      children: errorRadioSelectMsg,
    };
    if (!selectedLandlordRedux) {
      setErrorMsg(showRadioErrorMsg);
      setErrorList([{ ...showRadioErrorMsg, href: '#pmc-Landlords' }]);
    } else {
      window.location.assign('/evcg/pmcApp/select-grant-type');
      setErrorList(errorList);
    }
  };

  useEffect(() => {
    getAccount()
      .then((response) => {
        const { data } = response;
        dispatch(setPMCLandlordsData(data.pmc_client));
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.debug('Error while fetching account data:', err.message);
        setErrorMsg(err.message);
      });
  }, []);

  return (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <Fieldset
        legend={{
          children: (
            <h1 className="govuk-heading-xl">
              {copyProvider.getCopy(
                'pmcApp.ChooseLandlord.s2',
                'Who is this application for? '
              )}
            </h1>
          ),
        }}
      >
        <Radios
          idPrefix="pmc-Landlords"
          errorMessage={errorMsg || null}
          value={selectedLandlordRedux}
          onChange={handleSelectionBtn}
          items={pmcLandlordsDataRedux?.map((ll) => {
            return {
              children: ll.landlord_account_name || '',
              value: ll.landlord_account_id || '',
              key: ll.landlord_account_id || '',
            };
          })}
          name="pmc-Landlords"
        />
      </Fieldset>
      <Button
        className="govuk-button"
        id="continue-btn"
        onClick={handleSubmitButton}
      >
        {copyProvider.getCopy('pmcApp.ChooseLandlord.s3', 'Continue')}
      </Button>
    </>
  );
};

export default ChooseLandlord;
